// @mui material components
import Grid from "@mui/material/Grid";

import Stack from "@mui/material/Stack";
import { ethers } from "ethers";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";
import PieChart from "examples/Charts/PieChart";
import ClassicBetsTable from "layouts/classic/ClassicBetsTable";

import ContractBalances from "./components/ContractBalances";
import OperatorBalances from "./components/OperatorBalances";
import UserStatistics from "./components/UserStatistics";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import { shortened } from "helpers";
import Web3 from "web3";
import BigNumber from "bignumber.js";
import classicABI from "../../constants/classicABI";
import classicNewABI from "../../constants/classicNewABI";
import UserCard from "layouts/user/components/UserCard";

const web3Bsc = new Web3("https://bsc-dataseed3.defibit.io/");
const web3Matic = new Web3("https://polygon-rpc.com/");

const predictionsData = [
  {
    name: "BSC New",
    address: "0x00199E444155f6a06d74CF36315419d39b874f5c",
    interval: 300,
    network: 0,
    web3: web3Bsc,
    abi: classicNewABI,
    multiple: true,
    id: "0",
  },
  {
    name: "Poly New",
    address: "0x9f9564BE7b566dfE4B091a83a591752102aF3F33",
    interval: 300,
    network: 1,
    web3: web3Matic,
    abi: classicNewABI,
    multiple: true,
    id: "0",
  },
];

const predictionContracts = [];
for (let i = 0; i < predictionsData.length; i++) {
  const web3ToUse = predictionsData[i].web3;

  predictionContracts.push(
    new web3ToUse.eth.Contract(
      predictionsData[i].abi,
      predictionsData[i].address
    )
  );
}

const getNativeBalance = async (web3, address) => {
  const balanceWei = await web3.eth.getBalance(address);
  const balance = BigNumber(balanceWei.toString())
    .dividedBy(10 ** 18)
    .toFixed(2);
  return balance;
};

function Dashboard() {
  //const [network, setNetwork] = useState("BSC");
  const navigate = useNavigate();
  const { address } = useParams();
  const [predictions, setPredictions] = useState([]);
  const [dbUser, setDbUser] = useState();
  const [bets, setBets] = useState([]);
  const [enteredAddress, setEnteredAddress] = useState("");

  const loadAddress = () => {
    navigate("/classic/user/" + enteredAddress);
  };

  const loadPolygonBets = async () => {
    const graph =
      "https://api.studio.thegraph.com/query/76875/polynew/version/latest";

    const query = `query ($sender: String!) { 
    predictionsBets(first: 1000, where:{sender:$sender}, orderBy: timestamp, orderDirection: desc) {
      id
      predictionId
      currentEpoch
      amount
      position
      roundResult
      result
      sender
      timestamp
    }
}`;

    let results = await fetch(graph, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        query,
        variables: { sender: address },
      }),
    });

    const result = await results.json();
    let _bets = result.data.predictionsBets;
    _bets = _bets.map((b) => {
      return { ...b, network: "polygon" };
    });

    return _bets;
  };

  const loadBscBets = async () => {
    const graph =
      "https://api.studio.thegraph.com/query/76875/bnbnew/version/latest";

    const query = `query ($sender: String!) { 
    predictionsBets(first: 1000, where:{sender:$sender}, orderBy: timestamp, orderDirection: desc) {
      id
      predictionId
      currentEpoch
      amount
      position
      roundResult
      result
      sender
      timestamp
    }
}`;

    let results = await fetch(graph, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        query,
        variables: { sender: address },
      }),
    });

    const result = await results.json();
    let _bets = result.data.predictionsBets;
    _bets = _bets.map((b) => {
      return { ...b, network: "bsc" };
    });
    return _bets;
  };

  useEffect(() => {
    const loadData = async () => {
      if (!address) return;
      const betsPolygon = await loadPolygonBets();
      const betsBsc = await loadBscBets();
      let allBets = [...betsBsc, ...betsPolygon].sort(
        (a, b) => parseInt(b.timestamp) - parseInt(a.timestamp)
      );
      setBets(allBets);

      //LOAD USER DATA FROM DB
      const addressCheckSum = ethers.utils.getAddress(address);
      const userData = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/v1/dashboard/users/${addressCheckSum}`,
        {
          withCredentials: true,
        }
      );
      setDbUser(userData.data);
    };
    loadData();
  }, [address]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const blockNumber = await web3Bsc.eth.getBlockNumber();
        const block = await web3Bsc.eth.getBlock(blockNumber);
        const timestamp = block.timestamp;

        const predictions = [];

        const callsPre = [];
        const callsPost = [];

        for (let i = 0; i < predictionContracts.length; i++) {
          const predictionContract = predictionContracts[i];
          callsPre.push(predictionContract.methods.paused().call());
          callsPre.push(predictionContract.methods.currentEpoch().call());
        }

        const resultPre = await Promise.all(callsPre);

        for (let i = 0; i < predictionContracts.length; i++) {
          const predictionContract = predictionContracts[i];
          const roundNo = resultPre[i * 2 + 1];
          if (predictionsData[i].multiple)
            callsPost.push(
              predictionContract.methods
                .rounds(predictionsData[i].id, roundNo)
                .call()
            );
          else
            callsPost.push(predictionContract.methods.rounds(roundNo).call());
          callsPost.push(predictionContract.methods.timestamps(roundNo).call());
        }

        const resultPost = await Promise.all(callsPost);

        for (let i = 0; i < predictionContracts.length; i++) {
          const roundData = resultPost[i * 2];
          const timestamps = resultPost[i * 2 + 1];
          const paused = resultPre[i * 2];
          const currentRound = resultPre[i * 2 + 1];

          const balance = await getNativeBalance(
            predictionsData[i].web3,
            predictionsData[i].address
          );

          const timeOfLock = timestamps.lockTimestamp;
          const timeToLock = timeOfLock - timestamp;

          let text = paused ? "Paused" : timeToLock + " seconds";
          const slider =
            100 - (100 * parseInt(timeToLock)) / predictionsData[i].interval;
          const betUp = parseFloat(
            new BigNumber(roundData.bullAmount.toString())
              .dividedBy(10 ** 18)
              .toString()
          ).toFixed(3);
          const betDown = parseFloat(
            new BigNumber(roundData.bearAmount.toString())
              .dividedBy(10 ** 18)
              .toString()
          ).toFixed(3);

          predictions.push({
            name: predictionsData[i].name,
            currentRound,
            text,
            slider,
            betUp,
            betDown,
            balance,
          });
        }
        setPredictions(predictions);
      } catch (err) {
        console.log(err);
      }
    };

    loadData();
    const timer = setInterval(() => loadData(), 5000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!address && (
        <MDBox mt={8}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDInput
                fullWidth
                label="Enter user address"
                value={enteredAddress}
                variant="standard"
                onChange={(e) => setEnteredAddress(e.target.value)}
              />
              <MDButton
                fullWidth
                variant="gradient"
                color="info"
                size="small"
                onClick={loadAddress}
              >
                Load
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      )}
      {address && (
        <>
          {dbUser && (
            <Grid item xs={12}>
              <UserCard user={dbUser} />
            </Grid>
          )}
          <MDBox mb={3}>{dbUser?.nickname || ""}</MDBox>
          <MDBox mb={3}>
            <Grid item xs={12}>
              <UserStatistics address={address} />
            </Grid>
          </MDBox>
          <MDBox mb={3}>
            <Grid item xs={12}>
              <ClassicBetsTable data={bets} />
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  );
}

export default Dashboard;
